<template>
  <!-- <v-layout row wrap class="my-5 py-3">
    <v-flex xs12 sm12 md6 class="px-3 pb-3">
      <v-hover>
        <v-card
          min-height="35vmin"
          class="mb-3 secondary"
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2} cursor-pointer`"
          @click="$router.push({name: 'screeners.today'})"
        >
          <v-card-text
            class="d-flex align-center justify-center text-xs-center custom-card-text background--text"
          >
            <div>{{$t('screener.homepage.cube_1.heading')}}</div>
          </v-card-text>
        </v-card>
      </v-hover>
      <div
        class="subheading font-weight-medium text-align secondary--text"
      >{{$t('screener.homepage.cube_1.subheading')}}</div>
    </v-flex>
    <v-flex xs12 sm12 md6 class="px-3 pb-3">
      <v-hover>
        <v-card
          min-height="35vmin"
          class="mb-3 secondary"
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 12 : 2} cursor-pointer`"
          @click="$router.push({name: 'screeners.upcoming'})"
        >
          <v-card-text
            class="d-flex align-center justify-center text-xs-center custom-card-text background--text"
          >
            <div>{{$t('screener.homepage.cube_2.heading')}}</div>
          </v-card-text>
        </v-card>
      </v-hover>
      <div
        class="subheading font-weight-medium text-align secondary--text"
      >{{$t('screener.homepage.cube_2.subheading')}}</div>
    </v-flex>
  </v-layout> -->
  <div>
    <div v-if="company.id==136" class="pt-4">
      <video-background
        src="https://film-screening-public.fra1.cdn.digitaloceanspaces.com/production/promotional/AD22_Trailer_Festival_Final_2.mp4"
        style="max-height: 400px; height: 100vh;"
      >
      </video-background>
    </div>
    <div v-if="company.id==137" class="pt-4">
      <video-background
        src="https://film-screening-public.fra1.cdn.digitaloceanspaces.com/production/promotional/go_mental_trailer_2024-(540p).mp4"
        style="max-height: 400px; height: 100vh;"
      >
      </video-background>
    </div>
    <v-layout row wrap class="mt-4 pt-4">
      <v-flex xs-12 v-if="isOnGoingOrUpcomingEvents">
        <v-flex xs12 class="my-4 py-4 " v-if="ongoingList.data && ongoingList.data.length">
          <div
            :class="[
              'custom_heading primary--text mb-3',
              $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
            ]"
          >
            <span class="underline">{{ $t("screening.ongoing.title") }}</span>
          </div>
          <ScreenerList :list="ongoingList.data"> </ScreenerList>
          <v-layout align-center justify-center class="mb-2 mt-5">
            <v-btn
              color="primary background--text"
              @click="$router.push({ name: 'screeners.ongoing' })"
              >{{ $t("screening.ongoing.see_more_btn") }}</v-btn
            >
          </v-layout>
          <v-divider class="mt-5" />
        </v-flex>
        <v-flex class="my-4 py-4" xs12 v-if="upcomingList.data && upcomingList.data.length">
          <div
            :class="[
              'custom_heading primary--text mb-3',
              $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
            ]"
          >
            <span class="underline"> {{ $t("screening.upcoming.title") }}</span>
          </div>
          <ScreenerList :list="upcomingList.data"> </ScreenerList>
          <v-layout align-center justify-center class="mb-2 mt-5">
            <v-btn
              color="primary background--text"
              @click="$router.push({ name: 'screeners.upcoming' })"
              >{{ $t("screening.upcoming.see_more_btn") }}</v-btn
            >
          </v-layout>
          <v-divider class="mt-5" />
        </v-flex>
      </v-flex>
      <!-- <v-flex v-else class="my-5">
        <div
          :class="[
            'custom_heading',
            'primary--text',
            'text-xs-center',
          ]"
        >{{$t('screening.no_ongoing_upcoming_events.title')}}.
        </div>
      </v-flex> -->
      <v-flex xs12 class="my-4 py-4" v-if="vodList.data && vodList.data.length">
        <div
          :class="[
            'custom_heading primary--text mb-3',
            $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
          ]"
        >
          <span class="underline">{{ $t("screening.vod.title") }}</span>
        </div>
        <ScreenerList :list="vodList.data" :is_vod="true"> </ScreenerList>
        <v-layout align-center justify-center class="mb-2 mt-5">
          <v-btn
            color="primary background--text"
            @click="$router.push({ name: 'vod.movies' })"
            > <span class="underline">{{ $t("screening.vod.see_more_btn") }}</span></v-btn
          >
        </v-layout>
        <v-divider class="mt-5" />
      </v-flex>
      <v-flex class="my-4 py-4" xs12 v-if="archiveList.data && archiveList.data.length">
        <div
          :class="[
            'custom_heading primary--text mb-3',
            $vuetify.breakpoint.width < 959 ? 'text-xs-center' : null,
          ]"
        >
          <span class="underline">{{ $t("screening.past_events.title") }}</span>
        </div>
        <ScreenerList :list="archiveList.data" :is_past="true"> </ScreenerList>
        <v-layout align-center justify-center class="mb-2 mt-5">
          <v-btn
            class="mt-4"
            color="primary background--text"
            @click="$router.push({ name: 'screeners.archive' })"
            >{{ $t("screening.past_events.see_more_btn") }}</v-btn
          >
        </v-layout>
        <v-divider class="mt-5" />
      </v-flex>
    </v-layout>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import ScreenerList from "@/components/home/ScreenerList";
// import VideoBackground from 'vue-responsive-video-background-player'

export default {
  name: "Dashboard",
  components: {
    ScreenerList,
    // VideoBackground
  },
  computed: {
    ...mapState({
      upcomingList: (state) => state.screening.upcomingList,
      archiveList: (state) => state.screening.archiveList,
      vodList: (state) => state.screening.vodList,
      company: state => state.company.company
    }),
    ...mapGetters('screening',{
        ongoingList: "getOngoingScreenings",
    }),
    isOnGoingOrUpcomingEvents(){
        return (this.ongoingList.data && this.ongoingList.data.length)||(this.upcomingList.data && this.upcomingList.data.length)
    }
  },
  created() {
    this.getApiData();
  },
  methods: {
    async getApiData() {
      try {
        this.$store.dispatch("screening/upcomingList",{
          page: 1,
          perPage: 4,
        });
        this.$store.dispatch("screening/ongoingList",{
          page: 1,
          perPage: 4,
        });
        this.$store.dispatch("screening/listVodEvents",{
          page: 1,
          perPage: 4,
        });
        this.$store.dispatch("screening/archiveList", {
          page: 1,
          perPage: 4,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.text-align {
  text-align: justify;
}
.grey.lighten-5 {
  border: 1px solid var(--v-primary-base) !important;
  border-radius: 5px !important;
}
.custom-card-text {
  min-height: 35vmin;
  font-size: 5vh;
}
.custom_heading {
  font-size: 4vh;
}
.underline {
  border-bottom: 2px solid var(--v-primary-base);
}
</style>
